import React, { useState } from 'react';

const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const formData = new FormData(e.target);
    const userEmail = formData.get('email');
    const userName = formData.get('name');
    formData.append('_subject', `Neue Nachricht von ${userName || 'Ihrer Website'}`);
    formData.append('_replyto', userEmail);
    formData.append('_captcha', 'false');
    formData.append('_template', 'box');
    formData.append('_format', 'plain');
    formData.append('_AutooResponse', `Sehr geehrte/r ${userName},\n\nVielen Dank für Ihre Nachricht. Ich werde mich so schnell wie möglich bei Ihnen melden.\n\nMit freundlichen Grüßen,\nOrhan Yilmaz`);
    
    try {
      const response = await fetch('https://formsubmit.co/ajax/orhancodes@gmail.com', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const text = await response.text();
      let data;
      if (text) {
        try {
          data = JSON.parse(text);
        } catch {
          if (response.ok) {
            data = { success: true };
          } else {
            throw new Error('Invalid response format');
          }
        }
      } else if (response.ok) {
        data = { success: true };
      } else {
        throw new Error('Empty response');
      }
      
      if (data && (data.success === true || data.success === 'true')) {
        setSubmitStatus('success');
        e.target.reset();
        const url = new URL(window.location);
        url.searchParams.set('success', 'true');
        window.history.pushState({}, '', url);
        window.dispatchEvent(new Event('popstate'));
      } else {
        throw new Error(data?.message || 'Form submission failed');
      }
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Form submission error:', error);
      }
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="text" name="_honey" style={{display: 'none'}} tabIndex="-1" autoComplete="off" />
      
      <div className="form-row">
        <input
          type="text"
          name="name"
          id="name"
          placeholder="Gib deinen Namen ein"
          className="form-control"
          required
        />
        <input
          type="email"
          name="email"
          id="email"
          placeholder="Gib deine E-Mail-Adresse ein"
          className="form-control"
          required
        />
      </div>
      <div className="form-row">
        <textarea
          name="message"
          id="message"
          cols="30"
          rows="10"
          placeholder="Gib deine Nachricht ein"
          className="form-control"
          required
        ></textarea>
      </div>
      <button type="submit" className="btn" disabled={isSubmitting}>
        {isSubmitting ? 'Wird gesendet...' : 'Nachricht senden'}
      </button>
      
      {submitStatus === 'success' && (
        <div style={{ 
          marginTop: '1rem', 
          padding: '1rem', 
          background: 'rgba(76, 175, 80, 0.2)', 
          border: '1px solid rgba(76, 175, 80, 0.5)', 
          borderRadius: '8px',
          color: '#4caf50',
          textAlign: 'center'
        }}>
          Nachricht erfolgreich gesendet!
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div style={{ 
          marginTop: '1rem', 
          padding: '1rem', 
          background: 'rgba(244, 67, 54, 0.2)', 
          border: '1px solid rgba(244, 67, 54, 0.5)', 
          borderRadius: '8px',
          color: '#f44336',
          textAlign: 'center'
        }}>
          Fehler beim Senden. Bitte versuchen Sie es erneut.
        </div>
      )}
    </form>
  );
};

export default ContactForm;